<template>
  <div @dragover="allowSingleBind"
       @drop="(event) => dragToBaiduMapCmp(event, itemData, componentIndex)"
       class="map">
    <el-container style="height: 100%;width: 100%">
      <el-main style="height: 100%;padding:0">
        <el-container style="height: 100%;width: 100%">
          <div @mousedown="containerMouseDown"
               @mouseleave="canDrag=false"
               @mousemove="containerMousemove"
               @mouseup="containerMouseup"
               @touchend="containerMouseup"
               @touchmove="containerMousemove"
               @touchstart="containerMouseDown"
               class='detail-main'>
            <a>
            <el-aside style="padding:0 10px 0 10px;cursor:pointer" :class="{'mouseDrag':isDrag}" v-show="surfaceLevel===2" :width="leftWidth+'px'" onselectstart="return !this.isDrag">
              <div style="height: 95%;width: 100%"
                   @dragover="allowDataAdd"
                   @drop="(event) => dragDataToBaiduMapCmp(event, itemData, componentIndex)">
                <el-tooltip :open-delay="1000" class="item" effect="light" placement="left">
                  <div slot="content" style="text-align: center;font-size: 12px;font-weight: bold">双击回到信息概览界面<br/>右击进行设备管理
                  </div>
                  <el-card class="device-monitor-card" shadow="hover"
                           v-contextmenu:contextmenu>
                    <a>
                      <div style="width: 100%" @dblclick="switchSurfaceLevel(selectedDevice)"
                           onselectstart="return false">
                        <el-container style="width: 260px">
                          <el-main style="width: 100%;padding: 10px 0 0 0">
                            <el-row style="margin-top: 10px">
                              <div @click="switchShowStatus(selectedDevice)" style="cursor:pointer"
                                   v-if="selectedDevice.online">
                                <Icon :color="selectedDevice.color" size="40" style="float: left" type="md-eye"
                                      v-if="!selectedDevice.hide"/>
                                <Icon color="#585B63" size="40" style="float: left" type="md-eye-off" v-else/>
                              </div>
                              <img src="@/assets/gps_offline.png" style="float: left" v-else width="25px"/>
                              <p style="font-size: 14px;margin-left: 65px;margin-top: 10px">
                                {{selectedDevice.deviceName}}
                              </p>
                            </el-row>
                            <el-row>
                              <p style="font-size: 14px;text-align: center;color: #ff0000"
                                 v-if="selectedDevice.dependency===1">
                                缺少纬度信号</p>
                              <p style="font-size: 14px;text-align: center;color: #ff0000"
                                 v-else-if="selectedDevice.dependency===2">
                                缺少经度信号</p>
                              <div v-else>
                                <el-checkbox
                                  @change="changeTraceOption(selectedDevice.deviceId,selectedDevice.showTrace)"
                                  v-if="!selectedDevice.hide"
                                  v-model="selectedDevice.showTrace">显示轨迹
                                </el-checkbox>
                                <el-checkbox
                                  @change="changeCenterOption(selectedDevice.deviceId,selectedDevice.isCenter)"
                                  v-if="!selectedDevice.hide"
                                  v-model="selectedDevice.isCenter">中心跟随
                                </el-checkbox>
                              </div>
                            </el-row>
                          </el-main>
                          <el-aside style="width: 36px;padding: 4px">
                            <el-color-picker :predefine="predefineColors" @change="resetColor(selectedDevice)"
                                             size="mini"
                                             style="float: right;border: 0" v-model="selectedDevice.color">
                            </el-color-picker>
                          </el-aside>
                        </el-container>
                      </div>
                    </a>
                    <div class="monitor-info">
                      <el-divider></el-divider>
                      <a>
                        <p style="font-size: 16px;font-weight: bold;color: rgba(51, 137, 232, 1)">车辆详情</p>
                      <!--                      <el-table-->
<!--                        :data="monitorData"-->
<!--                        stripe-->
<!--                        style="width: 100%">-->
<!--                        <el-table-column-->
<!--                          label="参数"-->
<!--                          prop="name">-->
<!--                        </el-table-column>-->
<!--                        <el-table-column-->
<!--                          label="数值"-->
<!--                          prop="value">-->
<!--                        </el-table-column>-->
<!--                      </el-table>-->
                        <el-table
                            :data="displayVehicleData"
                            stripe
                            style="width: 100%">
                          <el-table-column
                              label="参数"
                              min-width="100"
                              prop="text">
                          </el-table-column>
                          <el-table-column
                              label="数值"
                              min-width="50"
                              prop="value">
                          </el-table-column>
                          <el-table-column
                              width="50"
                              align="center"
                              header-align="left"
                              label="操作">
                            <template slot-scope="scope">
                              <el-button @click="deleteDataSourceItem(scope.row)" icon="el-icon-delete" style="color: #222222"
                                         type="text"></el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </a>
                    </div>
                  </el-card>
                </el-tooltip>
              </div>
            </el-aside>
            </a>
            <el-main style="height: 100%;padding: 10px 0 10px 0px;position: relative">
              <a
                  @dragover="allowSingleBind"
                  @drop="(event) => dragToBaiduMapCmp(event, itemData, componentIndex)">
                <div
                  :class="{'main-container':mapNum==='单地图','left-container':mapNum==='双地图','monitor-map-container':surfaceLevel===2}"
                  id="container">
                </div>
                <div :class="{'right-container':mapNum==='双地图','hide':mapNum==='单地图'}" id="sub-container">
                </div>
              </a>
            </el-main>
            <el-aside style="width: 30%;padding: 10px 0 15px 10px;" v-show="surfaceLevel===2&&showExtra">
              <el-container style="width: 100%;height: 100%">
                <el-main style="padding: 0;overflow: hidden">
                  <embedded-video></embedded-video>
                </el-main>
                <el-footer style="height: 300px">
                  <el-divider></el-divider>
                  <p style="font-size: 16px;font-weight: bold;color: rgba(51, 137, 232, 1)">自定义信息</p>
                  <el-carousel :interval="5000" arrow="always" style="height: 220px">
                    <el-carousel-item :key="item" v-for="item in 5">
                      <h3>{{ item }}</h3>
                    </el-carousel-item>
                  </el-carousel>
                </el-footer>
              </el-container>
            </el-aside>
            <el-aside style="width: 285px;padding: 0 0 0 15px" v-show="surfaceLevel===1">
              <a>
                <v-contextmenu @contextmenu="setDeviceToDelete" ref="contextmenu">
                  <v-contextmenu-item @click="deleteDevice" style="font-size: 14px">删除设备</v-contextmenu-item>
                </v-contextmenu>
                <div style="text-align: right;margin: 10px 10px 10px 0">
                  <el-radio-group size="small" v-model="mapNum">
                    <el-radio-button label="单地图"></el-radio-button>
                    <el-radio-button label="双地图"></el-radio-button>
                  </el-radio-group>
                </div>
                <div :key="gpsDevice.deviceID" class="device-list" v-for="gpsDevice in gpsDeviceInfo">
                  <div @dblclick="switchSurfaceLevel(gpsDevice)" onselectstart="return false">
                    <el-tooltip :open-delay="1000" class="item" effect="light" placement="right">
                      <div slot="content" style="text-align: center;font-size: 12px;font-weight: bold">双击进入设备详情界面<br/>右击进行设备管理
                      </div>
                      <el-card class="device-card" shadow="hover"
                               v-contextmenu:contextmenu>
                        <el-container style="width: 100%">
                          <el-main style="width: 100%;padding: 10px 0 0 0">
                            <el-row style="margin-top: 10px">
                              <div @click="switchShowStatus(gpsDevice)" style="cursor:pointer"
                                   v-if="gpsDevice.online">
                                <Icon :color="gpsDevice.color" size="40" style="float: left" type="md-eye"
                                      v-if="!gpsDevice.hide"/>
                                <Icon color="#585B63" size="40" style="float: left" type="md-eye-off" v-else/>
                              </div>
                              <img src="@/assets/gps_offline.png" style="float: left" v-else width="25px"/>
                              <p style="font-size: 14px;margin-left: 65px;margin-top: 10px">{{gpsDevice.deviceName}}
                                <span @click="switchMapIndex(gpsDevice)" v-if="mapNum==='双地图'">
                    <i class="el-icon-d-arrow-right" style="font-size: 18px;font-weight: bold;float: right"
                       v-if="gpsDevice.mapIndex===0"></i>
                    <i class="el-icon-d-arrow-left" style="font-size: 18px;font-weight: bold;float: right"
                       v-if="gpsDevice.mapIndex===1"></i>
                      </span>
                              </p>
                            </el-row>
                            <el-row>
                              <p style="font-size: 14px;text-align: center;color: #ff0000"
                                 v-if="gpsDevice.dependency===1">
                                缺少纬度信号</p>
                              <p style="font-size: 14px;text-align: center;color: #ff0000"
                                 v-else-if="gpsDevice.dependency===2">
                                缺少经度信号</p>
                              <div v-else>
                                <el-checkbox @change="changeTraceOption(gpsDevice.deviceId,gpsDevice.showTrace)"
                                             v-if="!gpsDevice.hide"
                                             v-model="gpsDevice.showTrace">显示轨迹
                                </el-checkbox>
                                <el-checkbox @change="changeCenterOption(gpsDevice.deviceId,gpsDevice.isCenter)"
                                             style="margin-right: 10px"
                                             v-if="!gpsDevice.hide"
                                             v-model="gpsDevice.isCenter">中心跟随
                                </el-checkbox>
                              </div>
                            </el-row>
                          </el-main>
                          <el-aside style="width: 36px;padding: 4px">
                            <el-color-picker :predefine="predefineColors" @change="resetColor(gpsDevice)" size="mini"
                                             style="float: right;border: 0" v-model="gpsDevice.color">
                              style="float: right;border: 0" v-model="gpsDevice.color">
                            </el-color-picker>
                          </el-aside>
                        </el-container>
                      </el-card>
                    </el-tooltip>
                  </div>
                </div>
              </a>
            </el-aside>
          </div>
        </el-container>
      </el-main>
      <el-aside style="width: 20px;padding: 0">
        <div class="cmp-handle">
          <el-dropdown :hide-on-click="false">
                    <span class="el-dropdown-link">
                        <i class="el-input__icon el-icon-more" style="line-height: 20px;width: 20px"></i>
                    </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="getMockData(componentIndex,times,interval)">
                获取数据
              </el-dropdown-item>
              <el-dropdown-item>次数</el-dropdown-item>
              <el-dropdown-item>
                <el-input-number :max="9999" :min="1" size="mini" style="float: left;width: 100px"
                                 v-model="times">
                </el-input-number>
              </el-dropdown-item>
              <el-dropdown-item>间隔毫秒数</el-dropdown-item>
              <el-dropdown-item>
                <el-input-number :max="9999" :min="1" size="mini" style="float: left;width: 100px"
                                 v-model="interval">
                </el-input-number>
              </el-dropdown-item>
              <el-dropdown-item>显示轨迹点数</el-dropdown-item>
              <el-dropdown-item>
                <el-input-number :max="9999" :min="0" size="mini" style="float: left;width: 100px"
                                 v-model="pointNumLimit"></el-input-number>
              </el-dropdown-item>
              <el-dropdown-item @click.native="handleCmp('deleteMap', componentIndex)">删除地图
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <a>
          <div class="resize" v-show="surfaceLevel===2">
            <i class="el-icon-d-arrow-right" v-show="showExtra" @click="switchShowExtra()"></i>
            <i class="el-icon-d-arrow-left" v-show="!showExtra" @click="switchShowExtra()"></i>
          </div>
        </a>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
import BMap from 'BMap';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import projectDetailAPI from '@/api/projectDetail';
import { PROJECT_NODE_TYPE } from '@/common/enums';
import Video from '@/components/engineering/Video';

let mainMap;
let subMap;

export default {
  name: 'BaiduMap',
  components: { 'embedded-video': Video },
  data() {
    return {
      // 是否可以拖拽（鼠标点下去进行判断）
      canDrag: false,
      // 控制鼠标样式（是否在可以拖拽的位置）
      isDrag: false,
      dataSources: [],
      // 默认单地图
      mapNum: '单地图',
      ratio: 16,
      // 是否还为初始地图中心
      defaultCenterMain: true,
      defaultCenterSub: true,
      gpsDeviceInfo: [],
      predefineColors: [
        '#ff605b', '#647aff', '#57c3ff', '#ffac11', '#de91ff', '#ff9780', '#a6a6a6',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577',
      ],
      // 设置默认彩虹色
      colorList: ['#ff605b', '#647aff', '#57c3ff', '#ffac11', '#de91ff', '#ff9780', '#a6a6a6'],
      // 即将删除的设备
      deviceToDelete: '',
      // 信号量的key为键，设备名为值
      signalDeviceMap: new Map(),
      // 设备与其GPS点集的Map
      deviceDataMap: new Map(),
      // 设备与其当前位置Marker的映射
      deviceMarkerMap: new Map(),
      // 设备与其历史位置Marker列表的映射
      deviceOldMarkerMap: new Map(),
      // 默认保留最近100个点
      pointNumLimit: 100,
      // 当前界面等级，默认一级界面
      surfaceLevel: 1,
      // 二级界面对应车辆设备信息
      selectedDevice: {},
      // 测试专用，间隔单位为ms
      times: 100,
      interval: 1000,
      monitorData: [{
        name: '车辆状态',
        value: '正常',
      }, {
        name: '历史故障',
        value: '无',
      }, {
        name: '最大单体压差',
        value: '100mv',
      }, {
        name: '电池包温度',
        value: '39℃',
      }],
      vehicleData: [],
      deviceBindData: [
        // { deviceId: '271751609719980032',
        //   signalId: [
        //     'signal:283255560529248261.2.StuffingState2',
        //     'signal:283255560529248261.2.StuffingState1',
        //   ] },
        // { deviceId: '271751609719988832',
        //   signalId: [
        //     'signal:283255560529248261.2.RunState2',
        //     'signal:283255560529248261.2.RunState1',
        //   ] },
      ],
      // 显示视频和自定义信息区
      showExtra: true,
      // 车辆详情模块的宽度
      leftWidth: 290,
    };
  },
  mounted() {
    setTimeout(() => {
      this.startMainContainer();
      this.getMapConfig();
    }, 100);
  },
  computed: {
    ...mapState('Engineering', ['dragTreeNodeType', 'dragTreeNodeKey', 'panelDataCcg']),
    ...mapGetters('Engineering', ['getCurCmpStatus']),
    chartData() {
      return this.itemData.chartData || [];
    },
    dataSou() {
      return this.itemData.dataSources || [];
    },
    displayVehicleData() {
      const bind = this.deviceBindData;
      const vehicleData = this.vehicleData;
      if (this.selectedDevice.deviceId === undefined) {
        return [];
      }
      const deviceId = this.selectedDevice.deviceId;
      if (bind.length === 0) {
        return [];
      }
      const list = bind.filter(item => item.deviceId === deviceId);
      if (list.length === 0) {
        return [];
      }
      const data = vehicleData.filter(item => list[0].signalKeys.indexOf(item.key) > -1);
      return data;
    },
  },
  methods: {
    ...mapActions('Engineering', ['deleteCpt']),
    ...mapMutations('Engineering', [
      'addSignalToBaiduMap']),
    /**
       *@Description: 将gps原始单位的坐标由度.分转为小数表示的度
       *@Param: mod
       *@Author: SUN Hao
       *@date: 4/26/2019
       */

    unitCorrectedPoint(lng, lat) {
      lng = Math.floor(lng) + ((lng - Math.floor(lng)) / 0.6);
      lat = Math.floor(lat) + ((lat - Math.floor(lat)) / 0.6);
      return new BMap.Point(lng, lat);
    },

    /**
       *@Description: 将GPS坐标转为百度坐标
       *@Param: BMap.Point
       *@Author: SUN Hao
       *@date: 4/26/2019
       */
    translatePoint(lng, lat) {
      const point = this.unitCorrectedPoint(lng, lat);
      // 本地方法转换
      const translatedPoint = GpsToBaiduPoint(point);
      return new BMap.Point(translatedPoint[1], translatedPoint[0]);
    },

    // 开启主地图容器
    startMainContainer() {
      mainMap = new BMap.Map('container');
      mainMap.addControl(new BMap.MapTypeControl());
      const opts = { type: BMAP_NAVIGATION_CONTROL_SMALL };
      mainMap.addControl(new BMap.NavigationControl(opts));
      mainMap.enableScrollWheelZoom(true);
      // 默认外滩为初始地图中心点
      const point = new BMap.Point(121.49689, 31.242036);
      mainMap.centerAndZoom(point, this.ratio);
      this.getGpsDeviceInfo(this.componentIndex);
    },

    // 开启副地图容器
    startSubContainer() {
      subMap = new BMap.Map('sub-container');
      subMap.addControl(new BMap.MapTypeControl());
      const opts = { type: BMAP_NAVIGATION_CONTROL_SMALL };
      subMap.addControl(new BMap.NavigationControl(opts));
      subMap.enableScrollWheelZoom(true);
      // 默认外滩为初始地图中心点
      const point = new BMap.Point(121.49689, 31.242036);
      subMap.centerAndZoom(point, this.ratio);
    },

    // 进行绘图操作
    plot() {
      const opts = {
        width: 220, // 信息窗口宽度
        height: 85, // 信息窗口高度
        title: '<p style="font-size: 16px;font-weight: bold;color: #2258cc">当前点信息<span style="font-size: 12px">（百度坐标系）</span></p>', // 信息窗口标题
        enableMessage: true, // 设置允许信息窗发送短息
      };
      if (mainMap) {
        this.gpsDeviceInfo.map((item) => {
          const map = item.mapIndex === 0 ? mainMap : subMap;
          let marker;
          if (!item.hide) {
            if (this.deviceMarkerMap.has(item.deviceId)) {
              marker = this.deviceMarkerMap.get(item.deviceId);
              map.removeOverlay(marker);
            }
          }
          const pointArr = this.deviceDataMap.get(item.deviceId);
          const timeArr = this.deviceDataMap.get(`${item.deviceId}_time`);
          if (pointArr.length > 0) {
            const newPoint = pointArr[1];
            const newTime = this.formatTime(timeArr[1], 'Y-M-D h:m:s');
            if (this.defaultCenterMain && map === mainMap && ((this.surfaceLevel === 1) || (this.selectedDevice === item))) {
              map.centerAndZoom(newPoint, map.getZoom());
              this.defaultCenterMain = false;
            } else if (this.defaultCenterSub && map === subMap) {
              map.centerAndZoom(newPoint, map.getZoom());
              this.defaultCenterSub = false;
            }
            if (item.isCenter && ((this.surfaceLevel === 1) || (this.selectedDevice === item))) {
              // 设置一定的距离阈值，避免转换太频繁
              if (map.getDistance(newPoint, map.getCenter()) > 300) {
                map.centerAndZoom(newPoint, map.getZoom());
              }
            }
            if (pointArr[0] !== undefined) {
              const oldPoint = pointArr[0];
              const oldTime = this.formatTime(timeArr[0], 'Y-M-D h:m:s');
              this.saveOldMarker(map, item.deviceId, oldPoint, oldTime, newPoint, item.color, opts);
            }
            if (item.showTrace && ((this.surfaceLevel === 1) || (this.selectedDevice === item))) {
              this.singlePolyline(map, item.deviceId);
            }
            marker = new BMap.Marker(newPoint, {
              // 指定Marker的icon属性为Symbol
              icon: new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
                scale: 0.1 * map.getZoom(), // 图标缩放大小
                fillColor: item.color, // 填充颜色
                fillOpacity: 0.8, // 填充透明度
              }),
            });
            const info = `<p style="font-size: 14px">经度：${newPoint.lng.toString().substring(0, 8)}</p>
<p style="font-size: 14px">纬度：${newPoint.lat.toString().substring(0, 7)}</p>
<p style="font-size: 14px">时间：${newTime}</p></div>`;
            this.addClickHandler(map, info, marker, opts);
            this.deviceMarkerMap.set(item.deviceId, marker);
            if (!item.hide && ((this.surfaceLevel === 1) || (this.selectedDevice === item))) {
              map.addOverlay(marker);
            }
          }
        });
      }
    },

    // 保留旧的Marker集
    saveOldMarker(map, deviceId, oldPoint, oldTime, newPoint, color, opts) {
      // 画线损耗(加箭头)资源较多
      const pointArr = [];
      pointArr.push(oldPoint);
      pointArr.push(newPoint);
      const polyline = new BMap.Polyline(pointArr,
        { strokeColor: color, strokeWeight: 5, strokeOpacity: 0.5 },
      );
      const info = `<p style="font-size: 14px">经度：${oldPoint.lng.toString().substring(0, 8)}</p>
<p style="font-size: 14px">纬度：${oldPoint.lat.toString().substring(0, 7)}</p>
<p style="font-size: 14px">时间：${oldTime}</p></div>`;
      const marker = new BMap.Marker(oldPoint, {
        // 指定Marker的icon属性为Symbol
        icon: new BMap.Symbol(BMap_Symbol_SHAPE_STAR, {
          scale: 0.04 * map.getZoom(), // 图标缩放大小
          fillColor: color, // 填充颜色
          fillOpacity: 0.8, // 填充透明度
        }),
      });
      this.addClickHandler(map, info, marker, opts);
      if (this.deviceOldMarkerMap.has(deviceId)) {
        const markerArr = this.deviceOldMarkerMap.get(deviceId);
        markerArr.push(polyline);
        markerArr.push(marker);
      } else {
        const markerArr = [];
        markerArr.push(polyline);
        markerArr.push(marker);
        this.deviceOldMarkerMap.set(deviceId, markerArr);
      }
    },

    singlePolyline(map, deviceId) {
      if (this.deviceOldMarkerMap.has(deviceId)) {
        const markerArr = this.deviceOldMarkerMap.get(deviceId);
        const length = markerArr.length;
        const pointNum = (length / 2) + 1;
        map.addOverlay(markerArr[length - 2]);
        map.addOverlay(markerArr[length - 1]);
        if (pointNum >= this.pointNumLimit) {
          map.removeOverlay(markerArr[length - (2 * this.pointNumLimit)]);
          map.removeOverlay(markerArr[(length + 1) - (2 * this.pointNumLimit)]);
        }
      }
    },

    removePolyline(map, deviceId) {
      if (this.deviceOldMarkerMap.has(deviceId)) {
        const markerArr = this.deviceOldMarkerMap.get(deviceId);
        markerArr.map((marker) => {
          map.removeOverlay(marker);
        });
      }
    },

    allPolyline(map, deviceId) {
      if (this.deviceOldMarkerMap.has(deviceId)) {
        const markerArr = this.deviceOldMarkerMap.get(deviceId);
        const { length } = markerArr;
        const pointNum = (length / 2) + 1;
        const h = this.$createElement;
        if (this.pointNumLimit === 0) {
          this.$notify({
            title: '正在绘制中，请稍候',
            message: h('i', { style: 'color: teal' }, `当前轨迹共包含${pointNum}个坐标点`),
          });
          setTimeout(() => {
            for (let i = 0; i < length; i++) {
              map.addOverlay(markerArr[i]);
            }
          }, 500);
        } else {
          if (pointNum > this.pointNumLimit) {
            const text = `<p style="color: teal;font-size: 14px">当前轨迹共包含${pointNum}个坐标点</p>
                            <p style="color: teal;font-size: 14px">仅显示最近${this.pointNumLimit}个坐标点</p>
                            <p style="font-size: 12px">可在下拉菜单下进行修改 (0对应无限制)</p>`;
            this.$notify({
              title: '正在绘制中，请稍候',
              dangerouslyUseHTMLString: true,
              message: text,
            });
          } else {
            const text = `<p style="color: teal;font-size: 14px">当前设定为显示最近${this.pointNumLimit}个坐标点</p>
                            <p style="font-size: 12px">可在下拉菜单下进行修改 (0对应无限制)</p>`;
            this.$notify({
              title: '轨迹点设定提示',
              dangerouslyUseHTMLString: true,
              message: text,
            });
          }
          setTimeout(() => {
            for (let i = (length + 2) - (this.pointNumLimit * 2); i < length; i++) {
              map.addOverlay(markerArr[i]);
            }
          }, 500);
        }
      } else if (this.pointNumLimit !== 0) {
        const text = `<p style="color: teal;font-size: 14px">当前设定为显示最近${this.pointNumLimit}个坐标点</p>
                            <p style="font-size: 12px">可在下拉菜单下进行修改 (0对应无限制)</p>`;
        this.$notify({
          title: '轨迹点设定提示',
          dangerouslyUseHTMLString: true,
          message: text,
        });
      }
    },

    // 点击点时触发
    addClickHandler(map, content, marker, opts) {
      marker.addEventListener('click', (e) => {
        this.openInfo(map, content, e, opts);
      });
    },

    // 开启信息窗口
    openInfo(map, content, e, opts) {
      const p = e.target;
      const point = new BMap.Point(p.point.lng, p.point.lat);
      const infoWindow = new BMap.InfoWindow(content, opts); // 创建信息窗口对象
      map.openInfoWindow(infoWindow, point); // 开启信息窗口
    },

    dragToBaiduMapCmp(event, item, componentIndex) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      const isExistIndex = this.dataSources.findIndex(item2 => item2.key === this.dragTreeNodeKey);
      if (isExistIndex > -1) {
        this.$message({
          message: '无法拖拽重复的节点',
        });
        return;
      }

      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      if (dragNode.text === 'GPS_data0(0x1)') {
        const longIndex = dragNode.children.findIndex(signal => signal.text === 'Value_Long');
        const latIndex = dragNode.children.findIndex(signal => signal.text === 'Value_Lat');
        this.addSignalToBaiduMap({ dragNode: dragNode.children[longIndex], componentIndex });
        setTimeout(() => {
          this.addSignalToBaiduMap({ dragNode: dragNode.children[latIndex], componentIndex });
          setTimeout(() => {
            this.getGpsDeviceInfo(this.componentIndex);
          }, 500);
        }, 500);
      } else if (dragNode.text === 'Value_Long' || dragNode.text === 'Value_Lat') {
        this.addSignalToBaiduMap({ dragNode, componentIndex });
        setTimeout(() => {
          this.getGpsDeviceInfo(this.componentIndex);
        }, 500);
        this.$message.success(`成功添加信号${dragNode.text}`);
      } else {
        this.$message.info(`拒绝添加与地图无关的信号${dragNode.text}`);
      }
    },

    handleCmp(command, data) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'deleteMap':
          this.$confirm('确定删除地图?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              // 确认删除
              const index = data;
              this.deleteCpt({ index });
            }).then(() => {
              this.$message({
                message: '删除成功！',
              });
            })
            .catch((err) => {
            });
          break;
        default:
          break;
      }
    },

    allowSingleBind(event) {
      event.preventDefault();
      // 不允许Message & 允许观测量
      if (this.dragTreeNodeType === PROJECT_NODE_TYPE.DBC_SIGNAL || this.dragTreeNodeType === PROJECT_NODE_TYPE.A2L_MEASURE) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },

    allowDataAdd(event) {
      event.preventDefault();
      if (this.dragTreeNodeType === PROJECT_NODE_TYPE.DBC_SIGNAL || this.dragTreeNodeType === PROJECT_NODE_TYPE.A2L_MEASURE) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },

    dragDataToBaiduMapCmp(event, item, componentIndex) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      const isExistIndex = this.dataSources.findIndex(item2 => item2.key === this.dragTreeNodeKey);
      if (isExistIndex > -1) {
        this.$message({
          message: '无法拖拽重复的节点',
        });
      }
      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      this.addSignalToBaiduMap({ dragNode, componentIndex });
      // 配置设备与信号之间的映射关系并保存
      const deviceId = this.selectedDevice.deviceId;
      let index = -1;
      for (let i = 0; i < this.deviceBindData.length; i += 1) {
        if (this.deviceBindData[i].deviceId === deviceId) {
          index = i;
          break;
        }
      }
      if (index > -1) {
        this.deviceBindData[index].signalKeys.push(dragNode.id);
      } else {
        this.deviceBindData.push({
          deviceId,
          signalKeys: [dragNode.id],
        });
      }
      setTimeout(() => {
        projectDetailAPI.setMapConfig(this.itemData.cid, this.deviceBindData)
          .catch((err) => {
            this.$message.error('信号配置保存失败！');
          });
      }, 500);
    },

    getMapConfig() {
      projectDetailAPI.getMapConfig(this.itemData.cid)
        .then((res) => {
          console.log(res);
          if (res.deviceConfigs.length > 0) {
            this.deviceBindData = res.deviceConfigs;
          }
        });
    },

    /**
     * 删除数据源
     * @param rowData
     */
    deleteDataSourceItem(rowData) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      console.log(rowData);
      const { componentIndex } = this;
      this.$store.commit('Engineering/deleteDataSource', {
        cptIndex: componentIndex,
        dataSourceKey: rowData.key,
      });
      // const
    },

    // 获取当前被右键的节点名称，预设待删除设备名
    setDeviceToDelete(vnode) {
      const reg = /(.*)\n\n/;
      this.deviceToDelete = vnode.elm.innerText.match(reg)[1];
    },

    // 删除设备相关的所有信号
    deleteDevice() {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      const { componentIndex } = this;
      this.gpsDeviceInfo.forEach((item) => {
        if (item.deviceName === this.deviceToDelete) {
          // 删除信号1
          this.$store.commit('Engineering/deleteDataSource', {
            cptIndex: componentIndex,
            dataSourceKey: item.keyList[0],
          });
          // 删除信号2
          setTimeout(() => {
            this.$store.commit('Engineering/deleteDataSource', {
              cptIndex: componentIndex,
              dataSourceKey: item.keyList[1],
            });
          }, 500);
          setTimeout(() => {
            this.$message({
              message: `${this.deviceToDelete}删除成功！`,
            });
            this.getGpsDeviceInfo(this.componentIndex);
          }, 1000);

          // 跳出循环
          return false;
        }
      });
    },

    // 更改当前的隐藏状态
    switchShowStatus(gpsDevice) {
      const status = gpsDevice.hide;
      gpsDevice.hide = !status;
      const { deviceId } = gpsDevice;
      const map = gpsDevice.mapIndex === 0 ? mainMap : subMap;
      if (status) {
        if (this.deviceMarkerMap.has(deviceId)) {
          map.addOverlay(this.deviceMarkerMap.get(deviceId));
        }
      } else if (this.deviceMarkerMap.has(deviceId)) {
        gpsDevice.showTrace = false;
        gpsDevice.isCenter = false;
        this.removePolyline(map, deviceId);
        map.removeOverlay(this.deviceMarkerMap.get(deviceId));
      }
    },

    // 重设颜色
    resetColor(gpsDevice) {
      this.switchShowStatus(gpsDevice);
      this.switchShowStatus(gpsDevice);
      const h = this.$createElement;
      this.$notify({
        title: '颜色更改提示',
        message: h('i', { style: 'color: teal' }, '当前设置将于设备再次收到GPS数据时生效'),
      });
    },

    // 更改当前的地图序号
    switchMapIndex(gpsDevice) {
      const { mapIndex, deviceId } = gpsDevice;
      this.switchShowStatus(gpsDevice);
      gpsDevice.mapIndex = mapIndex === 0 ? 1 : 0;
      this.switchShowStatus(gpsDevice);
    },

    // 获取当前组件的GPS设备信息
    getGpsDeviceInfo(componentIndex) {
      const componentId = this.panelDataCcg[componentIndex].cid;
      let index = 0;
      projectDetailAPI.getGpsDeviceInfo(componentId)
        .then((res) => {
          this.gpsDeviceInfo = res;
          res.map((item) => {
            if (index < 7) {
              item.color = this.colorList[index];
            } else {
              // 随机色
              item.color = `#${Math.floor(Math.random() * 0xffffff).toString(16)}`;
            }
            if (!this.deviceDataMap.has(item.deviceId)) {
              this.deviceDataMap.set(item.deviceId, [undefined, undefined]);
              this.deviceDataMap.set(`${item.deviceId}_time`, [undefined, undefined]);
            }
            item.keyList.map((key) => {
              if (!this.signalDeviceMap.has(key)) {
                this.signalDeviceMap.set(key, item.deviceId);
              }
            });
            index += 1;
          });
        }).catch((err) => {
          console.log(err);
        });
    },

    // 参数number为毫秒时间戳，format为需要转换成的日期格式
    formatTime(number, format) {
      const time = new Date(number);
      const newArr = [];
      const formatArr = ['Y', 'M', 'D', 'h', 'm', 's'];
      newArr.push(time.getFullYear());
      newArr.push(this.formatNumber(time.getMonth() + 1));
      newArr.push(this.formatNumber(time.getDate()));

      newArr.push(this.formatNumber(time.getHours()));
      newArr.push(this.formatNumber(time.getMinutes()));
      newArr.push(this.formatNumber(time.getSeconds()));

      for (const i in newArr) {
        format = format.replace(formatArr[i], newArr[i]);
      }
      return format;
    },

    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : `0${n}`;
    },

    changeTraceOption(id, val) {
      const index = this.gpsDeviceInfo.findIndex(item => item.deviceId === id);
      const map = this.gpsDeviceInfo[index].mapIndex === 0 ? mainMap : subMap;
      if (val === true) {
        this.allPolyline(map, id);
      } else {
        this.removePolyline(map, id);
      }
    },

    changeCenterOption(id, val) {
      const index = this.gpsDeviceInfo.findIndex(item => item.deviceId === id);
      const map = this.gpsDeviceInfo[index].mapIndex === 0 ? mainMap : subMap;
      if (val) {
        const pointArr = this.deviceDataMap.get(id);
        if (pointArr.length > 0) {
          const newPoint = pointArr[1];
          // 设置一定的距离阈值，避免转换太频繁
          if (map.getDistance(newPoint, map.getCenter()) > 300) {
            map.centerAndZoom(newPoint, map.getZoom());
          }
        }
      }
    },
    switchSurfaceLevel(device) {
      if (this.surfaceLevel === 1) {
        this.surfaceLevel = 2;
        this.selectedDevice = device;
        this.mapNum = '单地图';
      } else {
        this.surfaceLevel = 1;
        this.selectedDevice = {};
      }
      // 重置轨迹路径及轨迹选项
      this.gpsDeviceInfo.map((item) => {
        if (item.showTrace === true) {
          this.changeTraceOption(item.deviceId, false);
          item.showTrace = false;
        }
      });
    },

    // 获取用于GPS测试的假数据
    getMockData(componentIndex, times, interval) {
      const panelId = this.$store.state.Engineering.panelId;
      const keyList = [];
      this.dataSources.map((item) => {
        keyList.push(item.key);
      });
      projectDetailAPI.getMapMockData(panelId, this.panelDataCcg[componentIndex].cid, keyList, times, interval)
        .then(() => {
          console.log('正在请求Mock数据');
        }).catch((err) => {
          console.log(err);
        });
    },

    // 切换额外信息区（视频+自定义区）的显示状态
    switchShowExtra() {
      this.showExtra = !this.showExtra;
    },
    // 鼠标移动事件，兼容触控
    containerMousemove(e) {
      // console.log(e);
      const _this = this;
      let touch;
      if (e.touches) {
        touch = e.touches[0];
      } else {
        touch = e;
      }
      const { canDrag } = this;
      // 鼠标距离html最左侧距离
      const L = touch.clientX;
      const curWidth = _this.distanceToLeft + _this.leftWidth;
      window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
      _this.isDrag = L > curWidth - 20 && L < curWidth + 5;
      // 左边拖动
      // if (L > leftWidth - 3 && L < leftWidth + 5) {
      _this.leftWidth = canDrag ? L - _this.distanceToLeft : _this.leftWidth;
    },
    // 鼠标按下事件，兼容触控
    containerMouseDown(e) {
      const _this = this;
      let touch;
      if (e.touches) {
        touch = e.touches[0];
      } else {
        touch = e;
      }
      const curWidth = _this.distanceToLeft + _this.leftWidth;
      const L = touch.clientX;
      _this.canDrag = (L > curWidth - 20 && L < curWidth + 5);
    },
    // 鼠标抬起事件，兼容触控
    containerMouseup() {
      this.canDrag = false;
    },
  },
  props: {
    itemData: {
      type: Object,
      default() {
        return [];
      },
    },
    // 当前组件的index
    componentIndex: {
      type: Number,
      default: 0,
    },

    // 当前组件离左侧的距离
    distanceToLeft: {
      type: Number,
      default: 500,
    },
  },
  watch: {
    pointNumLimit() {
      let text;
      if (this.pointNumLimit === 0) {
        text = '<p style="color: teal;font-size: 14px">设定已更改为显示全部轨迹点</p>' +
            '<p style="font-size: 12px">设备显示轨迹选项已重置</p>';
      } else {
        text = `<p style="color: teal;font-size: 14px">设定已更改为显示最近${this.pointNumLimit}个坐标点</p>
<p style="font-size: 12px">设备显示轨迹选项已重置</p>`;
      }
      this.$notify({
        title: '设定更改提示',
        dangerouslyUseHTMLString: true,
        message: text,
      });
      this.gpsDeviceInfo.map((item) => {
        if (item.showTrace === true) {
          this.changeTraceOption(item.deviceId, false);
          item.showTrace = false;
        }
      });
    },
    mapNum() {
      if (this.mapNum === '双地图') {
        this.startSubContainer();
      } else {
        this.gpsDeviceInfo.map((item) => {
          if (item.mapIndex === 1) {
            this.switchMapIndex(item);
          }
        });
        // 恢复sub地图的初始属性
        this.defaultCenterSub = false;
        subMap = null;
      }
    },
    dataSou: {
      handler(newDataSou) {
        const self = this;
        self.dataSources = [];
        self.vehicleData = [];
        for (let i = 0; i < newDataSou.length; i += 1) {
          // console.log(newDataSou[i].text)
          // console.log(newDataSou[i].text.indexOf('Value_Lat'));
          // console.log(newDataSou[i].text.indexOf('Value_Long'));
          // console.log('____')
          if (newDataSou[i].text.indexOf('Value_Lat') > -1 || newDataSou[i].text.indexOf('Value_Long') > -1) {
            self.dataSources.push({
              text: newDataSou[i].text,
              key: newDataSou[i].key,
              value: 0,
              unit: '',
            });
          } else {
            self.vehicleData.push({
              text: newDataSou[i].text,
              key: newDataSou[i].key,
              value: newDataSou[i].value,
              unit: '',
            });
          }
        }
        // self.dataSources = newDataSou.map(item => ({
        //   text: item.text,
        //   key: item.key,
        //   value: 0,
        //   unit: '',
        // }));
      },
      deep: true,
      immediate: true,
    },
    chartData: {
      handler(newChartData = []) {
        const self = this;
        const data = new Map();
        if (newChartData.length > 0) {
          newChartData.forEach((item) => {
            // 增加信号实时上传
            const index = self.vehicleData.findIndex(item2 => item2.key === item.key);
            if (index > -1) {
              self.vehicleData[index].value = item.values[0].value;
            }
            const device = this.signalDeviceMap.get(item.key);
            let single = {};
            if (data.has(device)) {
              single = data.get(device);
            } else {
              data.set(device, single);
            }
            single.time = (new Date()).getTime();
            if (item.key.indexOf('Value_Lat') > -1) {
              single.lat = item.values[0].value;
            } else {
              single.lng = item.values[0].value;
            }
            data.set(device, single);
            if (single.lat && single.lng) {
              if (self.deviceDataMap.get(device) !== undefined) {
                // 位置0对应旧制，位置1对应新值
                self.deviceDataMap.get(device)[0] = self.deviceDataMap.get(device)[1];
                self.deviceDataMap.get(device)[1] = self.translatePoint(single.lng, single.lat);
                self.deviceDataMap.get(`${device}_time`)[0] = self.deviceDataMap.get(`${device}_time`)[1];
                self.deviceDataMap.get(`${device}_time`)[1] = single.time;
                data.set(device, {});
              }
            }
          });
        }
        this.plot();
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss">
  @import "../../style/mixin.scss";
  @import "../../style/media";

  .map {
    width: 100%;
    height: 100%;

    .detail-main {
      display: flex;
      flex-wrap: nowrap;
    }

    .main-container {
      width: 100%;
      height: 100%;
    }

    .left-container {
      width: 49.5% !important;
      float: left;
    }

    .right-container {
      width: 49.5% !important;
      height: 100% !important;
      float: right;
    }

    .hide {
      display: none;
    }

    .cmp-handle {
      height: 20px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }

    #container, #sub-container {
      width: 100%;
      height: 100%;

      .anchorBL {
        display: none;
      }
    }

    .el-card__body {
      padding: 0 0 10px 15px;
      height: 100%;
    }

    .el-color-picker__trigger {
      border: 0;
    }

    .device-card {
      width: 260px;
      margin-top: 10px;
    }

    .device-monitor-card {
      width: 100%;
      overflow: auto;

      .el-card__body {
        padding: 15px;
        height: 100%;
      }

      margin-top: 10px;
      height: 100%;

      .monitor-info {
        margin-top: 20px;
        min-width:260px;
      }
    }

    .el-carousel__item h3 {
      text-align: center;
      color: rgba(51, 137, 232, 1);
      font-size: 100px;
      opacity: 0.75;
      line-height: 100%;
      padding-top: 10%;
    }

    .el-carousel__container {
      position: relative;
      height: 100%;
    }

    .resize {
      float: right !important;
      font-size: 18px;
      position: absolute;
      top: 50%;
      margin-top: -20px;
      cursor: pointer
    }

    .mouseDrag {
      cursor: col-resize !important;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/engineering/BaiduMap.vue